import React from 'react';
import { MessageSquare, Paperclip, Clock, CheckSquare } from 'lucide-react';
import { PRIORITY, TASK_TYPE, fmt } from '../../utils';
import { AvatarGroup } from '../UI/Avatar';

export default function TaskCard({ task, onClick }) {
  const p = PRIORITY[task.priority];
  const t = TASK_TYPE[task.type];
  const due = fmt.dueBadge(task.dueDate);
  const checkDone = task.checklist?.filter(c => c.done).length || 0;
  const checkTotal = task.checklist?.length || 0;

  return (
    <div onClick={onClick}
      className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-3 cursor-pointer hover:border-brand-300 dark:hover:border-brand-700 hover:shadow-sm transition-all group">

      {/* Type + Priority */}
      <div className="flex items-center gap-1.5 mb-2">
        <span className="text-xs" title={t?.label}>{t?.icon}</span>
        <span className="text-xs text-gray-400 font-mono">{task.number ? `#${task.number}` : ''}</span>
        <span className="ml-auto text-sm" title={p?.label}>{p?.icon}</span>
      </div>

      {/* Title */}
      <p className="text-sm font-medium leading-snug mb-2 group-hover:text-brand-600 dark:group-hover:text-brand-400 transition-colors line-clamp-2">
        {task.title}
      </p>

      {/* Tags */}
      {task.tags?.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-2">
          {task.tags.slice(0, 3).map(tag => (
            <span key={tag} className="px-1.5 py-0.5 rounded text-[10px] bg-brand-50 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400">{tag}</span>
          ))}
        </div>
      )}

      {/* Footer */}
      <div className="flex items-center gap-2 mt-2">
        {task.assignees?.length > 0 && <AvatarGroup users={task.assignees} max={2} />}
        <div className="flex-1" />

        {due && <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${due.cls}`}>{due.label}</span>}

        {checkTotal > 0 && (
          <span className="flex items-center gap-0.5 text-[10px] text-gray-400">
            <CheckSquare className="w-3 h-3" />{checkDone}/{checkTotal}
          </span>
        )}
        {task.comments?.length > 0 && (
          <span className="flex items-center gap-0.5 text-[10px] text-gray-400">
            <MessageSquare className="w-3 h-3" />{task.comments.length}
          </span>
        )}
      </div>
    </div>
  );
}
